import React, { useEffect, useState, useRef } from 'react';
import PageLayout from '@/components/PageLayout';
import { Card, CardContent } from '@/components/ui/card';
import { motion, useInView, useAnimation } from 'framer-motion';
import { Helmet } from 'react-helmet';


const comptData = [

  {
    name: 'IA/ML',
    description: 'Je travaille avec des modèles d\'IA comme Llama et Claude pour créer des solutions IA. Mes projets incluent l\'intégration d\'APIs d\'IA, le fine-tuning de modèles et le développement d\'applications IA pratiques.',
    color: 'from-purple-600 to-pink-600',
    bgColor: 'bg-purple-50',
  },

  {
    name: 'UI/UX Design',
    description: 'La conception d\'interfaces utilisateur est au cœur de mes projets. J\'utilise Figma pour créer des wireframes et des prototypes interactifs, des applicactions basées sur de l\'IA pour la création UI de haute qualité.',
    color: 'from-blue-500 to-cyan-500',
    bgColor: 'bg-blue-50',
  },

  {
    name: 'RAG & LLMs',
    description: 'Je développe des systèmes RAG en utilisant des LLMs. Cela permet de créer des assistants IA personnalisés avec une connaissance spécifique au domaine.',
    color: 'from-purple-500 to-blue-500',
    bgColor: 'bg-purple-50',
  },
  {
    name: 'No-Code & Low-Code',
    description: 'J\'utilise des plateformes comme Flutterflow et Supabase pour créer rapidement des MVPs et des solutions business. Cette approche permet d\'accélérer le développement.',
    color: 'from-blue-600 to-blue-900',
    bgColor: 'bg-blue-50',
  },
  {
    name: 'Serverless & Cloud Architecture ',
    description: 'Je m\'implique dans l\'installation et la configuration de serveurs et la migration des services vers le cloud. J\'ai adopté l\'approche serverless me permettant de me concentrer sur l\'application front.',
    color: 'from-orange-500 to-red-600',
    bgColor: 'bg-orange-50',
  },
];


// Skill data
const skillsData = [
  {
    name: 'Photoshop',
    description: 'Mon outil magique pour la création graphique. Je l\'utilise quotidiennement pour créer des visuels percutants et les assets graphiques de mes projets.',
    icon: '/bucket/skills/photoshop.svg',
    color: 'from-blue-600 to-blue-900',
    bgColor: 'bg-blue-50',
  },
  {
    name: 'Canva',
    description: 'Outil de prédilection pour la création de mes contenus visuels pour les réseaux sociaux et les présentations. Il est simple à utiliser et produit des designs professionnels en un temps record.',
    icon: '/bucket/skills/canva.svg',
    color: 'from-purple-500 to-blue-500',
    bgColor: 'bg-purple-50',
  },
  {
    name: 'Figma',
    description: 'Mon outil principal pour le prototypage UI/UX et la conception d\'interfaces. Pour créer des wireframes, des maquettes interactives avec beaucoup de simplicité.',
    icon: '/bucket/skills/figma.svg',
    color: 'from-purple-600 to-pink-600',
    bgColor: 'bg-pink-50',
  },
  {
    name: 'Filmora',
    description: 'Un développeur est un créateur de contenu donc pour créer des tutoriels, des présentations animées vaut mieux un outil simple et performant.',
    icon: '/bucket/skills/filmora.svg',
    color: 'from-green-500 to-emerald-700',
    bgColor: 'bg-green-50',
  },
  {
    name: 'Web Analytics',
    description: 'Le SEO, l\'analyse des performances Web sont importants. Google Analytics et CloudFlare Web Analytics sont tous 2 gratuits et permettent de suivre tout le trafic Web.',
    icon: '/bucket/skills/web.svg',
    color: 'from-blue-500 to-cyan-500',
    bgColor: 'bg-blue-50',
  },
  {
    name: 'Meta Business Suite',
    description: 'Gérer les réseaux sociaux n\'est pas aussi simple que vous le pensez. Meta est peut être la meilleure solution pour gérer les réseaux sociaux.',
    icon: '/bucket/skills/meta.svg',
    color: 'from-blue-600 to-indigo-800',
    bgColor: 'bg-indigo-50',
  },
  {
    name: 'Metricool',
    description: 'Un autre outil de planification de réseaux sociaux que j\'utilise pour programmer les publications. C\'est simple et ça fait beaucoup de choses.',
    icon: '/bucket/skills/metricool.svg',
    color: 'from-teal-500 to-green-500',
    bgColor: 'bg-leo-teal-50',
  },
  {
    name: 'Flutter',
    description: 'Framework moderne pour créer des applications mobiles performantes et esthétiques. Sa flexibilité me permet de déployer rapidement sur Android.',
    icon: '/bucket/skills/flutter.svg',
    color: 'from-blue-400 to-cyan-600',
    bgColor: 'bg-cyan-50',
  },
  {
    name: 'React',
    description: 'Prémier choix front-end que j\'utilise pour développer des interfaces utilisateur interactives et réactives. L\'écosystème très riche de React permet de gérer des projets web modernes.',
    icon: '/bucket/skills/react.svg',
    color: 'from-cyan-500 to-blue-600',
    bgColor: 'bg-cyan-50',
  },
  {
    name: 'FlutterFlow',
    description: 'Plateforme no-code pour développer rapidement des applications Flutter sans code. Un bon début pour commencer à créer des applications mobile avec Flutter en tirant parti de ses fonctionnalités sans code.',
    icon: '/bucket/skills/flutterflow.png',
    color: 'from-cyan-800 to-blue-700',
    bgColor: 'bg-cyan-80',
  },
  {
    name: 'Supabase',
    description: 'Tout le monde connait ce nom. Supabase est juste la meilleure platefome Baas. Une base de données, des services en temps réel, des webhooks et des fonctions serverless bref je recommande.',
    icon: '/bucket/skills/supabase.png',
    color: 'from-green-500 to-green-700',
    bgColor: 'bg-green-50',
  },
  {
    name: 'GPC',
    description: 'Google Workspace est super mais c\'est quand tu automatises ta messagérie, ton calendrier que tu découvres la magie de l\'Automatisation et des API.',
    icon: '/bucket/skills/gpc.png',
    color: 'from-blue-500 to-blue-700',
    bgColor: 'bg-blue-50',
  },
  {
    name: 'CloudFlare',
    description: 'Plateforme pour la sécurité en ligne que j\'utilise pour protéger et optimiser les performances de mes applications avec les CDN. C\'est gratuit, c\'est puissant et surtout bien documentée.',
    icon: '/bucket/skills/cloudflare.png',
    color: 'from-orange-400 to-orange-600',
    bgColor: 'bg-orange-50',
  },
{
    name: 'Azure',
    description: 'Je découvre le cloud computing et le MLOps. J\'explore les services cloud, le déploiement d\'applications, la gestion des serveurs, et l\'automatisation des workflows ML.',
    icon: '/bucket/skills/azure.png',
    color: 'from-blue-400 to-blue-600',
    bgColor: 'bg-blue-50',
  },
  {
    name: 'Docker',
    description: 'J\'utilise Docker pour conteneuriser des applications et faciliter le développement local avant le deploiement sur le Cloud, particulièrement pour les projets LLM et RAG.',
    icon: '/bucket/skills/docker.png',
    color: 'from-blue-400 to-blue-600',
    bgColor: 'bg-blue-50',
  },
  {
    name: 'Pinecone',
    description: 'Base de données simple pour découper et stocker les informations necessaires à la mise en place du Knowledge Base du Chatbot. J\'utilise Pinecone pour créer un RAG avec mes propres fichiers.',
    icon: '/bucket/skills/pinecone.png',
    color: 'from-black to-black',
    bgColor: 'bg-black-60',
  },
  {
    name: 'PyTorch',
    description: 'Je débute mon apprentissage du machine learning et du deep learning avec PyTorch. J\'explore les concepts fondamentaux et expérimente avec des modèles simples pour comprendre les bases.',
    icon: '/bucket/skills/pytorch.png',
    color: 'from-red-400 to-red-500',
    bgColor: 'bg-red-50',
  },
  {
    name: 'LangChain',
    description: 'Framework que j\'utilise avec HuggingFace et Pinecone pour créer des chatbots IA. Il permet de structurer le développement d\'agents conversationnels et de setup des systèmes RAG.',
    icon: '/bucket/skills/langchain.png',
    color: 'from-green-300 to-green-500',
    bgColor: 'bg-green-50',
  },
  {
    name: 'n8n',
    description: 'Plateforme d\'automatisation que j\'utilise pour créer des workflows sophistiqués. Je l\'exploite pour gérer des intégrations entre différents services, automatiser les processus et construire des pipelines de données personnalisés.',
    icon: '/bucket/skills/n8n.png',
    color: 'from-red-400 to-red-600',
    bgColor: 'bg-red-60',
  },
  {
    name: 'Make',
    description: 'Plateforme d\'automatisation que j\'utilise pour créer des webhooks et automatiser les interactions sur mon site web. Make Permet de simplifier les workflows et d\'améliorer l\'expérience utilisateur.',
    icon: '/bucket/skills/make.png',
    color: 'from-purple-400 to-[#8f28d9]',
    bgColor: 'bg-[#8f28d9]-200',
  },
  {
    name: 'HuggingFace',
    description: 'Source inestimable d\'outils LLM et de modèles pré-entraînés pour développer des applications d\'IA. Sa communauté active et ses ressources open-source en font une plateforme essentielle pour mes projets d\'IA.',
    icon: '/bucket/skills/huggingface.png',
    color: 'from-yellow-300 to-yellow-500',
    bgColor: 'bg-yellow-50',
  },
];




const Skills = () => {
  const [loading, setLoading] = useState(true);
  const [activeSkill, setActiveSkill] = useState(0);
  const [activeCompt, setActiveCompt] = useState(0);
  const [progressValues, setProgressValues] = useState(skillsData.map(() => 0));
  
  const sectionRef = useRef(null);
  const section1Ref = useRef(null);


  // Animation Trigger
  const useAnimateOnScroll = (refs, animationClass) => {
   useEffect(() => {
     const observer = new IntersectionObserver(
       (entries) => {
         entries.forEach(entry => {
           if (entry.isIntersecting) {
             entry.target.classList.add('animate__animated', animationClass);
             observer.unobserve(entry.target);
           }
         });
       },
       { threshold: 0.3 }
     );
 
     refs.forEach(ref => {
       if (ref.current) observer.observe(ref.current);
     });
 
     return () => observer.disconnect();
   }, [refs, animationClass]);
 };

 useAnimateOnScroll([sectionRef], 'animate__backInRight');
 useAnimateOnScroll([section1Ref], 'animate__fadeInUp');



  // Refs for scroll animations
  const skillRefs = useRef(skillsData.map(() => React.createRef()));
  const heroRef = useRef(null);
  const cardRefs = useRef([]);

 useEffect(() => {
  cardRefs.current = cardRefs.current.slice(0, skillsData.length);
 }, []);
 

  
  // Animation controls
  const heroControls = useAnimation();
  
  // Check if hero is in view
  const heroInView = useInView(heroRef, { once: true, amount: 0.3 });
  
  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);
    
    return () => clearTimeout(timer);
  }, []);
  
  // Animate hero section when in view
  useEffect(() => {
    if (heroInView) {
      heroControls.start("visible");
    }
  }, [heroControls, heroInView]);
  
  // Animate progress bars when skills become active
  useEffect(() => {
    const timer = setTimeout(() => {
      setProgressValues(prevValues => {
        const newValues = [...prevValues];
        return newValues;
      });
    }, 300);
    
    return () => clearTimeout(timer);
  }, [activeSkill,activeCompt ]);
  
  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.3,
      }
    }
  };
  
  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  };
  
  const heroVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.8, ease: "easeOut" }
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen w-screen flex items-center justify-center gradient-bg">
        <div className="w-64 h-64">
        </div>
      </div>
    );
  }

  return (
    <>
    <Helmet>
    <title>Mopaossi | Compétences</title>
    <meta
      name="description"
      content="Développeur Frontend | No-code| Low-code | UI/UX | Agilité"
    />
    <meta property="og:title" content="Mopaossi | Développeur Créatif" />
    <meta
      property="og:description"
      content="Découvrer un créateur, digitalisation, tech, app, dev : Mes sujets préférés."
    />
    <meta property="og:type" content="website" />
    <link rel="canonical" href="https://cbenji.pages.dev" />
  </Helmet>
    <PageLayout
      title="Mopaossi | Compétences"
      description="Tous mes skills en un seul endroit"
    >
      {/* Hero Section with 3D Animated Image */}
      <motion.div
          ref={heroRef}
          animate={heroControls}
          variants={heroVariants}
          className="py-20 md:py-20"
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col-reverse lg:flex-row items-center justify-between gap-10">
              {/* Left: Text and Buttons */}
              <div className="w-full lg:w-1/2 mt-8 lg:mt-0">
                <h1 className="text-4xl md:text-5xl font-bold mb-6">
                  <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 via-purple-600 to-blue-600 animate-gradient">
                    Mes Compétences
                  </span>
                </h1>
                <p className="text-lg md:text-xl text-gray-700 mb-8">
                  Un ensemble d'outils et de technologies que j'utilise quotidiennement pour créer des expériences numériques exceptionnelles.
                </p>
                <div className="flex flex-wrap gap-3">
                  {comptData.map((compt, index) => (
                    <button
                      key={index}
                      className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
                        activeCompt === index 
                          ? `bg-gradient-to-r ${compt.color} text-white shadow-md` 
                          : `${compt.bgColor} text-gray-700 hover:shadow-sm`
                      }`}
                      onClick={() => setActiveCompt(index)}
                    >
                      {compt.name}
                    </button>
                  ))}
                </div>
              </div>
              {/* Right: 3D Animated Image */}
              <div 
             ref={sectionRef}
              className="w-full lg:w-1/2 flex justify-center items-center">
                <div className=" w-80  rounded-2xl  flex items-center justify-center">
                  <img 
                    src="https://hynmctzoemxttjsmvjyz.supabase.co/storage/v1/object/public/images//skills.png"
                    alt="Skills Icon"
                    className=" object-contain"
                  />
                  {/* Optional: Add a subtle floating effect */}
                  <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 w-32 h-4 bg-gradient-to-r from-blue-300 via-purple-300 to-blue-300 rounded-full blur-md opacity-40"></div>
                </div>
              </div>
            </div>
            {/* Animated Skill Card (below buttons, mobile friendly) */}
            <div className="mt-10 w-full flex justify-center">
              <div className="w-full max-w-md bg-white/90 backdrop-blur rounded-2xl shadow-lg p-6 flex flex-col items-center">
               
                <h2 className={`text-2xl font-bold mb-2 bg-clip-text text-transparent bg-gradient-to-r ${comptData[activeSkill].color}`}>
                  {comptData[activeCompt].name}
                </h2>
                <p className="text-gray-700 text-center mb-4">
                  {comptData[activeCompt].description}
                </p>
              </div>
            </div>
          </div>
        </motion.div>
        
        {/* Skills Grid */}
        <motion.div
          ref={section1Ref}
          initial="hidden"
          animate="visible"
          variants={containerVariants}
          className="py-16"
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold mb-12 text-center">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-purple-600 via-blue-600 to-purple-600 animate-gradient">
                Mon Arsenal Technique
              </span>
            </h2>
            
            <div 
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {skillsData.map((skill, index) => (
                <motion.div
                  key={index}
                  variants={itemVariants}
                  data-index={index}
                  ref={(el) => (cardRefs.current[index] = el)}
                  whileHover={{ y: -5, transition: { duration: 0.3 } }}
                  className="h-full"
                >
                  <Card
                  className={`border-none shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden h-full ${skill.bgColor}`}>
                    <div className={`h-2 bg-gradient-to-r ${skill.color}`}></div>
                    <CardContent className="p-6">
                      <div className="flex items-center mb-4">
                        <div className="w-12 h-12 mr-4">
                          <img 
                            src={skill.icon} 
                            alt={skill.name}
                            className="w-full h-full object-contain"
                          />
                        </div>
                        <h3 className={`text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r ${skill.color}`}>
                          {skill.name}
                        </h3>
                      </div>
                      
                      <p className="text-gray-700 mb-6">
                        {skill.description}
                      </p>
                      
                      <div className="mt-auto">
                      </div>
                    </CardContent>
                  </Card>
                </motion.div>
              ))}
            </div>
          </div>
        </motion.div>
        
        {/* Call to Action */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.8 }}
          className="py-16 md:py-24 text-center"
        >
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold mb-6">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 via-purple-600 to-blue-600 animate-gradient">
                Prêt à collaborer ?
              </span>
            </h2>
            <p className="text-xl text-gray-700 mb-8">
              Avec cet arsenal d'outils et de compétences, je peux vous aider à concrétiser vos projets numériques.
            </p>
            <motion.a
              href="/contact"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="inline-block px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white font-bold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300"
            >
              Discutons de votre projet
            </motion.a>
          </div>
        </motion.div>
    </PageLayout>
    </>
  );
};

export default Skills;